import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useBankAccounts } from './hooks/useBankAccounts';
import { useCustomers } from './hooks/useCustomers';
import LoanPairSummaryCard from './components/cards/LoanPairSummaryCard';

// หน้า "ยืม-คืน" หลัก — เดิมมีทั้ง header banner + ปุ่มสร้าง/แก้ไขคู่บัญชี + การ์ดสรุป/
// ประวัติ ตอนนี้เหลือแค่ดูข้อมูลของคู่หลัก (bankAccounts[0]) อย่างเดียว ไม่มี header เลย
// (ตัดตามที่ผู้ใช้ขอ) ส่วนกำหนด/แก้ไขบัญชีของคู่ยืม-คืน (สร้างคู่ใหม่, สลับ Customer,
// รองรับหลายคู่) ย้ายไปหน้า /accounting/loan-pairs-setup แทนแล้ว (LoanPairSetup.js) —
// หน้านี้ใช้บ่อยกว่ามาก เลยให้เข้าถึงตรงๆ ไม่ต้องเจอ header/ปุ่มจัดการที่ไม่ได้ใช้บ่อย
export function LoanPairs() {
  const { bankAccounts, loading, reload } = useBankAccounts();
  const { customerName } = useCustomers();
  const mainPair = bankAccounts.find((account) => account.mode === 'BALANCE');

  return (
    <Box sx={{ maxWidth: 1600, mx: 'auto', pb: 2 }}>
      {loading ? null : !mainPair ? (
        <Paper variant="outlined" sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, borderStyle: 'dashed', textAlign: 'center', bgcolor: '#fafafa' }}>
          <Typography variant="h6" sx={{ fontWeight: 750 }}>ยังไม่มีคู่ยืม-คืน</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            ไปที่เมนู &quot;ตั้งค่าคู่ยืม-คืน&quot; เพื่อกำหนดบัญชีฝั่งยืมและฝั่งคืนก่อน
          </Typography>
        </Paper>
      ) : (
        <LoanPairSummaryCard pair={mainPair} customerName={customerName} onSaved={reload} />
      )}
    </Box>
  );
}

export default LoanPairs;
